import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import type { SxProps, Theme } from "@mui/material";
import type { MouseEvent } from "react";

import { useDynamicTranslation } from "@/hooks/useDynamicTranslation";

export interface NeedHelpProps {
  /**
   * Accepted for compatibility with existing callers. The legacy component
   * does not apply this value, so it remains intentionally unused.
   */
  sx?: SxProps<Theme>;
}

export function NeedHelp(_props: NeedHelpProps) {
  const { t } = useDynamicTranslation("money-transfer");

  const handleLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const newTab = window.open("/sss", "_blank");
    newTab!.focus();
  };

  return (
    // The click handler intentionally opens this internal route in a new tab.
    // eslint-disable-next-line @next/next/no-html-link-for-pages
    <a href="/sss" onClick={handleLinkClick} style={{ color: "inherit", textDecoration: "none" }}>
      <HeadsetMicOutlinedIcon sx={{ verticalAlign: "middle", mr: 1 }} />
      {t("needHelp")}
    </a>
  );
}
